// Game is the main app component that builds the full page.

import LevelController from 'app/src/game/LevelController';
import ModalContainerController from 'app/src/modals/ModalContainerController';
import EditorPage from 'app/src/pages/EditorPage';
import LevelPage from 'app/src/pages/LevelPage';
import MainMenuPage from 'app/src/pages/MainMenuPage';
import * as React from 'react';
import { DndProvider } from 'react-dnd';
import Backend from 'react-dnd-html5-backend';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';

export default function Game(): React.ReactElement | null {
	return (
		<ModalContainerController>
			<DndProvider backend={Backend}>
				<LevelController>
					<Router>
						<Switch>
							<Route exact path="/">
								<MainMenuPage />
							</Route>
							<Route path="/level/:level">
								<LevelPage />
							</Route>
							<Route path="/editor">
								<EditorPage />
							</Route>
							<Route path="*">
								<Redirect to="/" />
							</Route>
						</Switch>
					</Router>
				</LevelController>
			</DndProvider>
		</ModalContainerController>
	);
}
